import { CSSProperties } from "react";

export const XCenteredAbsolute = ({
  children,
  style,
}: {
  children?: React.ReactNode;
  style?: CSSProperties;
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {children}
    </div>
  );
};
